import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Box from 'components/box';
import Input from 'form/input';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import {DocumentLink, DocumentWarning} from 'components/documents';
import Spinner from 'spinner';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import close from 'images/general/close.svg';

import {changeDocumentFile, submitNewDocument, changeDocumentValue, loadDocumentDetail, documentCleanStore, documentCleanErrors} from 'redux/actions/admin/documents';
import {equals, gt, not, path} from "ramda";
import styled from "styled-components";

const ErrorBlock = styled(DocumentWarning)`
  color: rgb(218,156,21);
  
  @media screen and (max-width: 600px) {
    font-size: 12px;
  }
`

const mapStateToProps = (state) => ({
  file: state.adminDocuments.get('documentFile'),
  item: state.adminDocuments.get('documentItem'),
  isSubmitting: state.adminDocuments.get('documentIsSubmitting'),
  hasError: state.adminDocuments.get('documentCreateFailed'),
  limitError: state.adminDocuments.get('limitMaxSize')
}); 
 
const mapDispatchToProps = (dispatch) => ({
  onValueChange: (value, key) => dispatch(changeDocumentValue(value, key)),
  onMount: (id) => dispatch(loadDocumentDetail(id)),
  onFileChange: event => dispatch(changeDocumentFile(event.target)),
  onSubmit: id => dispatch(submitNewDocument('/admin/documents/detail/', id)),
  onClean: () => dispatch(documentCleanStore()),
  cleanErrors: () => dispatch(documentCleanErrors())
});

class CreateDocument extends Component {

  state = {
    modalOpen: false,
    error: false,
    errorMsg: ''
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  loadFile = event => {
    this.props.cleanErrors()
    const maxSize = 16000000
    if(not(equals(path(['target', 'files', 0, 'type'], event), 'application/pdf'))) {
      this.generateError('Вибраний файл не в форматі pdf')
    } else if (gt(path(['target', 'files', 0, 'size'], event), maxSize)){
      this.generateError('Вибраний файл більше ніж 16 мб')
    } else {
      this.removeError()
      this.props.onFileChange(event)
    }
  }

  onSubmitForm = event => {
    event.preventDefault()
    if(!this.state.error) {
      this.props.onSubmit(this.props.match.params.document_id)
    }
  }

  generateError = msg => this.setState(()=> ({ error: true, errorMsg: msg }))

  renderError = () => this.state.error && <ErrorBlock>{this.state.errorMsg}</ErrorBlock>

  removeError = () => this.setState(() => ({ error: false, errorMsg: '' }))

  componentDidMount() {
    this.props.cleanErrors()
    if (this.props.match.params.document_id !== undefined) {
      this.props.onMount(this.props.match.params.document_id)
    } else {
      this.props.onClean();
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.hasError) {
      const fileError = path(['attachment', 0], nextProps.hasError)

      if (fileError && fileError.indexOf('Ensure this filename has at most 100 characters') > -1) {
        this.generateError('Назва файлу має містити не більше ніж 100 символів')
      } else {
        this.generateError('Виникла помилка при збереженні документу')
      }
    }
  }

  componentWillUnmount () {
    this.props.cleanErrors()
  }

  render() {
    if(this.props.isSubmitting) return <Spinner />

    return (
      <div>
          {this.props.match.params.document_id ? (
              <Breadcrumbs>
                  <li><Link to="/admin/">Головна</Link></li>
                  <li><Link to="/admin/documents/">Документи</Link></li>
                  <li><p>Редагування документу</p></li>
              </Breadcrumbs>
          ):(
              <Breadcrumbs>
                  <li><Link to="/admin/">Головна</Link></li>
                  <li><Link to="/admin/documents/">Документи</Link></li>
                  <li><p>Створення документу</p></li>
              </Breadcrumbs>
          )}
        <PageHead>
          <h2>{this.props.match.params.document_id ? "Редагувати документ" : "Cтворити документ"}</h2>
        </PageHead>

        <Box title4={this.props.match.params.document_id ? "Форма редагування документа" : "Форма створення документа"}>
          <form onSubmit={this.onSubmitForm}>
            <Input
              label="Назва документа"
              placeholder="Введіть назву документа"
              required
              max={250}
              value={this.props.item.get('name') ? this.props.item.get('name'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'name')}
            />
            <Input
              type="text"
              label="Номер документа"
              placeholder="0"
              required
              max={250}
              value={this.props.item.get('number') ? this.props.item.get('number') : ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'number')}
            />
            <Input
              label="Короткий опис документа"
              placeholder="Введіть короткий опис документа"
              required
              max={500}
              value={this.props.item.get('description') ? this.props.item.get('description') : ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'description')}
            />

            {this.props.match.params.document_id && (
              <DocumentLink><span><strong>Прикріплений документ:</strong></span>
                <a href={this.props.item.get('attachment')} target="_blank">{this.props.item.get('name')}</a>
              </DocumentLink>
            )}

            <Input
              type="file"
              accept=".pdf"
              required = {not(this.props.match.params.document_id)}
              label={this.props.match.params.document_id ? "Змінити документ" : "Виберіть документ"}
              placeholder="Виберіть файл"
              onChange={this.loadFile}
            />
            <DocumentWarning>
              Можна завантажувати лише файли в форматі <strong>.pdf</strong>
            </DocumentWarning>
            {this.props.limitError ? (
              <DocumentWarning>
                <span style={{color: "red"}}>Занадто великий файл для завантаження</span>
            </DocumentWarning>
            ):(
              null
            )}
            {this.renderError()}

            {this.props.isSubmitting ? (
              <ButtonDefault disabled type="submit" value="Зберегти"/>
            ):(
              <ButtonDefault type="submit" value="Зберегти"/>
            )}
              <ButtonDefault onClick={this.toggleModal} value="Вийти без збереження"/>
          </form>
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
};

CreateDocument.propTypes = {
  title: PropTypes.string,
  number: PropTypes.number,
  description: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDocument);



// WEBPACK FOOTER //
// ./src/admin/documents/create.js